var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 20 20","width":"20","height":"20"}},[_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M2 18L18 2M2 1.999l16 16"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }